import React from 'react';
import { Plus } from 'lucide-react';
import { useCart } from '../context/CartContext';

const ProductCard = ({ product }) => {
  const { addToCart, cart } = useCart();

  const handleAddToCart = () => {
    if (product.min_quantity) {
      const existing = cart.find(item => item.id === product.id);
      if (!existing) {
        addToCart(product, product.min_quantity);
      } else {
        addToCart(product);
      }
    } else {
      addToCart(product);
    }
  };

  const altText = `${product.name} rental - ${product.description} | Thomas Party & Decor Havertown PA`;

  return (
    <div
      className="bg-white rounded-3xl p-4 shadow-lg hover:shadow-2xl hover:-translate-y-2 hover:scale-[1.02] transition-all duration-300 border-2 border-orange-100"
      data-testid={`product-card-${product.id}`}
      itemScope
      itemType="https://schema.org/Product"
    >
      <meta itemProp="sku" content={product.id} />
      <meta itemProp="brand" content="Thomas Party & Decor" />

      <div className="relative overflow-hidden rounded-xl aspect-square mb-4 bg-gray-50">
        <img
          src={product.image}
          alt={altText}
          className="w-full h-full object-contain"
          loading="lazy"
          decoding="async"
          width="400"
          height="400"
          itemProp="image"
        />
      </div>

      <h3
        className="text-xl font-bold heading-font mb-2"
        style={{ color: '#7C3AED' }}
        data-testid={`product-name-${product.id}`}
        itemProp="name"
      >
        {product.name}
      </h3>

      <p
        className="text-sm text-gray-600 mb-3"
        data-testid={`product-description-${product.id}`}
        itemProp="description"
      >
        {product.description}
      </p>

      {product.min_quantity && (
        <p className="text-xs font-semibold text-red-500 mb-2" data-testid={`min-order-${product.id}`}>
          Min. order: {product.min_quantity}
        </p>
      )}

      <div className="flex items-center justify-between" itemProp="offers" itemScope itemType="https://schema.org/Offer">
        <meta itemProp="priceCurrency" content="USD" />
        <meta itemProp="availability" content="https://schema.org/InStock" />
        <span
          className="bg-yellow-100 text-orange-600 font-bold px-3 py-1 rounded-full text-lg"
          data-testid={`product-price-${product.id}`}
        >
          $<span itemProp="price" content={product.price.toFixed(2)}>{product.price.toFixed(2)}</span>
        </span>

        <button
          onClick={handleAddToCart}
          className="bg-orange-500 hover:bg-orange-600 hover:scale-110 active:scale-90 text-white px-5 py-2 rounded-full font-semibold shadow-md flex items-center gap-2 transition-all duration-200"
          data-testid={`add-to-cart-${product.id}`}
        >
          <Plus size={18} /> Add
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
